var getParameterByName = function(name) {
  var url = new URL(window.location.href);
  var params = new URLSearchParams(url.search.slice(1));
  var values = params.getAll(name);

  if (!values || !values.length) {
    return null;
  }

  if (values.length === 1) {
    return values[0];
  }

  return values;
}

var sizeChange = function(mq, id, maxWidthDesktop, maxHeightDesktop, maxWidthMobile) {
  if (mq.matches) {
    $('.ProductImage-' + id).css('max-width', maxWidthDesktop + 'px');
    $('.ProductImage-' + id).css('max-height', maxHeightDesktop + 'px');
    $('#ProductImageWrapper-' + id).css('max-width', maxWidthDesktop + 'px');
  } else {
    $('.ProductImage-' + id).css('max-width', maxWidthMobile + 'px');
    $('#ProductImageWrapper-' + id).css('max-width', maxWidthMobile + 'px');
  }
}

var refreshParameters = function () {
  scopioSearchQuery = getParameterByName('q');
  scopioSearchPage = getParameterByName('page');
  scopioSearchType = getParameterByName('t');
  scopioSearchCLevel = getParameterByName('clevel');
  scopioSearchLicense = getParameterByName('license');
  searchType = getParameterByName('search_type');
  selectedCountry = getParameterByName('country');
  selectedCity = getParameterByName('city');
  selectedGender = getParameterByName('gender');
  selectedEthnicities = getParameterByName('ethnicity');
  selectedSkills = getParameterByName('skills');
  selectedOrientation = getParameterByName('orientation');
  locationCity = getParameterByName('location_city');
  locationState = getParameterByName('location_state');
  locationCountry = getParameterByName('location_country');

  lastDocumentHeightLoaded = 0;
  isSearchLoading = false;
  scrollId = '';
  handlesLoaded = {};
  idsLoaded = {};
  totalSearchResults = 0;
  imagesLoaded = 0;
  cityChanged = false;
  placeRetrieved = false;

  if(!scopioSearchLicense) {
    scopioSearchLicense = 'all';
  }

  if(!scopioSearchPage) {
    scopioSearchPage = 1;
  }

  if (!searchType) {
    searchType = 'images';
  }

  if(fieldLicense && (scopioSearchLicense === 'all' || scopioSearchLicense === 'commercial' || scopioSearchLicense === 'editorial')) {
    fieldLicense.value = scopioSearchLicense;
  }

  if(fieldLicense && (scopioSearchLicense === 'horizontal' || scopioSearchLicense === 'vertical' || scopioSearchLicense === 'square')) {
    fieldLicense.value = scopioSearchLicense;
  }

  if(searchBarInput) {
    searchBarInput.value = scopioSearchQuery;
  }

  if(searchFieldMobile) {
    searchFieldMobile.value = scopioSearchQuery;
  }

  if(searchTypeField) {
    searchTypeField.value = searchType;
  }

  if(scopioSearchCLevel === null) {
    scopioSearchCLevel = 0;
  }
};

var configSearchType = function() {
  if (!searchForm) {
    return;
  }

  document.getElementById('dropdown-search-type-value').textContent = searchType;

  document.querySelectorAll('.small-dropdown-wrapper__search-type-wrapper .search-type').forEach((searchTypeLink) => {
    if (searchTypeLink.dataset.searchType === searchType) {
      searchTypeLink.classList.add('selected-search-type');
    } else if (searchTypeLink.classList.contains('selected-search-type')) {
      searchTypeLink.classList.remove('selected-search-type');
    }
  });

  divLoadingSearch.style.display = 'flex';

  divRelatedSearchesWrapper.style.display = 'none';

  if(searchFormSpacing.classList.contains('with-related-searches')) {
    searchFormSpacing.classList.remove('with-related-searches');
  }

  countFilters = 0;

  if (selectedCountry && countryField.querySelectorAll(`option[value="${selectedCountry}"]`).length > 0) {
    countryField.value = selectedCountry;
    countryFieldMob.value = selectedCountry;

    document.getElementById('lbcountcountry').textContent = '(1)';
    countFilters++;

    configAutocomplete();
  }

  if (selectedCity) {
    cityField.value = selectedCity;
    cityFieldMob.value = selectedCity;

    document.getElementById('lbcountcountry').textContent = '(2)';
    countFilters++;
  }

  if (searchType === 'people') {
    if (document.body.classList.contains('images-search')) {
      document.body.classList.remove('images-search');
    }

    if (!document.body.classList.contains('people-search')) {
      document.body.classList.add('people-search');
    }

    divSearchResults.style.display = 'none';
    divPeopleSearchResults.style.display = 'grid';

    if (selectedGender) {
      searchForm.querySelectorAll(`input[type="radio"][data-type="gender"][value="${selectedGender}"]`).forEach((gender) => {
        gender.checked = true;
      });

      document.getElementById('lbcountgender').textContent = '(1)';
      countFilters++;
    }

    if (selectedEthnicities) {
      if (!Array.isArray(selectedEthnicities)) {
        selectedEthnicities = [selectedEthnicities];
      }

      selectedEthnicities.forEach((selectedEthnicity) => {
        if (selectedEthnicity) {
          searchForm.querySelectorAll(`input[type="checkbox"][data-type="ethnicity"][value="${selectedEthnicity}"]`).forEach((ethnicity) => {
            ethnicity.checked = true;
          });
        }
      });

      document.getElementById('lbcountethnicity').textContent = '(' + selectedEthnicities.length + ')';
      countFilters += selectedEthnicities.length;
    }

    if (selectedSkills) {
      if (!Array.isArray(selectedSkills)) {
        selectedSkills = [selectedSkills];
      }

      selectedSkills.forEach((selectedSkill) => {
        if (selectedSkill) {
          searchForm.querySelectorAll(`input[type="checkbox"][data-type="skills"][value="${selectedSkill}"]`).forEach((skill) => {
            skill.checked = true;
          });
        }
      });

      document.getElementById('lbcountskills').textContent = '(' + selectedSkills.length + ')';
      countFilters += selectedSkills.length;
    }

    document.getElementById('lbcountfilters').textContent = '(' + countFilters + ')';

    if (searchForm.classList.contains('search-type-images')) {
      searchForm.classList.remove('search-type-images');
    }

    searchForm.classList.add('search-type-people');
  } else if (searchType === 'images') {
    if (document.body.classList.contains('people-search')) {
      document.body.classList.remove('people-search');
    }

    if (!document.body.classList.contains('images-search')) {
      document.body.classList.add('images-search');
    }

    divPeopleSearchResults.style.display = 'none';
    divSearchResults.style.height = 'auto';
    divSearchResults.style.display = 'block';

    if (scopioSearchLicense) {
      searchForm.querySelectorAll(`input[type="radio"][data-type="license"][value="${scopioSearchLicense}"]`).forEach((license) => {
        license.checked = true;
      });

      if (scopioSearchLicense === 'commercial' || scopioSearchLicense === 'editorial') {
        document.getElementById('lbcountlicense').textContent = '(1)';
      }
    }

    if (selectedOrientation) {
      searchForm.querySelectorAll(`input[type="radio"][data-type="orientation"][value="${selectedOrientation}"]`).forEach((orientation) => {
        orientation.checked = true;
      });

      document.getElementById('lbcountorientation').textContent = '(1)';
    }

    if (searchForm.classList.contains('search-type-people')) {
      searchForm.classList.remove('search-type-people');
    }

    searchForm.classList.add('search-type-images');
  }
}

var configAutocomplete = function() {
  if (!autocompleteCity || !autocompleteCityMob) {
    setTimeout(configAutocomplete, 100);
    return;
  }

  autocompleteCity.setComponentRestrictions({
    country: selectedCountry,
  });

  autocompleteCityMob.setComponentRestrictions({
    country: selectedCountry,
  });
};

var scopioSearchQuery = null;
var scopioSearchPage = null;
var scopioSearchType = null;
var scopioSearchCLevel = null;
var scopioSearchLicense = null;
var searchType = null;
var selectedCountry = null;
var selectedCity = null;
var selectedGender = null;
var selectedEthnicities = null;
var selectedSkills = null;
var selectedOrientation = null;
var scrollId = '';
var carouselBtnWidth = 36;
var heightDesktop = window.innerWidth / 5;
var lastDocumentHeightLoaded = 0;
var isSearchLoading = false;
var isHomepage = false;
var isProductPage = false;
var lastSearchParams = null;
var isPageLoading = true;
var customerBoards = [];
var customerBoardsLoaded = false;
var autocompleteCity = null;
var autocompleteCityMob = null;
var locationCity = null;
var locationState = null;
var locationCountry = null;
var areBoardsAvailable = true;
var idsLoaded = {};
var handlesLoaded = {};
var scopioSearchPageSize = 100;
var totalSearchResults = 0;
var imagesLoaded = 0;
var stateChanged = false;
var searchFormWrapperOffset = null;
var cityChanged = false;
var placeRetrieved = false;
var countFilters = 0;
var resizeListenerContainerId = null;
var currentJustifiedGallery = null;

var searchForm = document.getElementById('search-form');
var searchBarInput = document.getElementById('search-bar-input');
var searchFieldMobile = document.getElementById('search-field-mobile');
var searchNoResults = document.getElementById('seach-no-results');
var editorialSearchNoResults = document.getElementById('editorial-search-no-results');
var editorialCollectionContainer = document.getElementById('editorial-collection');
var searchFormWrapper = document.getElementById('search-form-wrapper');
var mainPageWrapper = document.getElementById('main-page-wrapper');
var searchFormSpacing = document.getElementById('search-form-spacing');
var unableToFind = document.getElementById('unable-to-find');
var noExactMatches = document.getElementById('no-exact-matches');
var fieldLicense = document.getElementById('search_license');
var labelLicense = document.getElementById('license');
var divSearchResults = document.getElementById('scopio-search-results');
var divLoadingSearch = document.getElementById('loading-search');
var divPeopleSearchResults = document.getElementById('scopio-people-search-results');
var divAdditionalSearchResults = document.getElementById('scopio-additional-search-results');
var divRelatedSearches = document.getElementById('related-searches');
var divRelatedSearchesWrapper = document.getElementById('related-searches--wrapper');
var aCarouselPrev = document.getElementById('carousel__prev');
var aCarouselNext = document.getElementById('carousel__next');
var countryField = document.getElementById('select_country');
var countryFieldMob = document.getElementById('select_country_mob');
var cityField = document.getElementById('city');
var cityFieldMob = document.getElementById('city_mob');
var genderFields = document.getElementsByName('gender');
var genderMobFields = document.getElementsByName('gender_mob');
var ethnicityFields = document.getElementsByName('ethnicity');
var skillsFields = document.getElementsByName('skills');
var licenseFields = document.getElementsByName('license');
var licenseMobFields = document.getElementsByName('license_mob');
var orientationFields = document.getElementsByName('orientation');
var orientationMobFields = document.getElementsByName('orientation_mob');
var btnClearCountry = document.getElementById('clear_country');
var btnClearGender = document.getElementById('clear_gender');
var btnClearEthnicity = document.getElementById('clear_ethnicity');
var btnClearSkills = document.getElementById('clear_skills');
var btnClearLicense = document.getElementById('clear_license');
var btnClearOrientation = document.getElementById('clear_orientation');
var btnClearMob = document.getElementById('clear_mob');
var searchTypeField = document.getElementById('search_type');

var scopioSearchUrl = 'https://search.scop.io/search';
// var scopioSearchUrl = 'https://test-search.scop.io/search';
var scopioStoriesPeopleSearchUrl = 'https://search.scop.io/people-story-search';
// var scopioStoriesPeopleSearchUrl = 'https://test-search.scop.io/social-search';

refreshParameters();

configSearchType();

var justify = function(containerId) {
  var container = document.getElementById(containerId);

  if (!container || !container.childNodes || !container.childNodes.length) {
    return;
  }

  var maxRowHeight = null;

  if(mobilecheck() === true) {
  	heightDesktop = 200;
    maxRowHeight = 320;
  } else {
    heightDesktop = 300;
    maxRowHeight = 480;
  }

  try {
    $('#' + containerId).justifiedGallery({
      lastRow : 'nojustify',
      margins : 6,
      border: 10,
      rowHeight: heightDesktop,
      maxRowHeight: maxRowHeight,
      sizeRangeSuffixes: {
        'lt100':'_100x',
        'lt240':'_240x',
        'lt320':'_320x',
        'lt500':'_500x',
        'lt640':'_640x',
        'lt1024':'_1024x',
        'lt1280':'_1280x',
      }
    });
  } catch (e) {
    console.log('container ' + containerId + ' null.');
  }
};

var validateJustifyResize = function(containerId, event) {
  var container = document.getElementById(containerId);

  if (container || !container.childNodes || !container.childNodes.length) {
    container.style.height = 'auto';
    event.preventDefault();
  }
}

var recreateSearchResults = function() {
  divSearchResults.remove();
  divSearchResults = document.createElement('div');
  divSearchResults.setAttribute('id', 'scopio-search-results');

  divLoadingSearch.after(divSearchResults);
};

var createBoardOption = function(board) {
  var option = document.createElement('div');
  option.innerText = board.name;
  option.className = "board-option-item";
  option.id = board.id;
  option.addEventListener("click", function(event){
    var selectedBoard = event.srcElement.id;
    var currentImg = event.target.parentElement.parentElement.parentElement.parentElement.children[1].id;
    var currentDropdown = document.getElementById(event.target.parentElement.parentElement.id);
    addImageToBoard(selectedBoard, currentImg);
    currentDropdown.style.display = "none";
  });

  return option;
};

var addBoardToAllPhotos = function(board) {
  document.querySelectorAll('.board-dropdown-options-grid').forEach(function(el) {
    for (const child of el.childNodes) {
      if (child.id === board.id) {
        return;
      }
    }

  	var option = createBoardOption(board);
    el.appendChild(option);
  });
};

var updateBoards = function() {
  for(var board of customerBoards){
    addBoardToAllPhotos(board);
  }
};

var addToBoardAction = function(event) {
  if(areBoardsAvailable === false) {
    var requestUpgradeAlertEvent = new CustomEvent("alert_upgrade_requested");
    document.dispatchEvent(requestUpgradeAlertEvent);
    return;
  }

  const customerToken = Cookies.get('scopio_customer_token');
  const productId = event.target.parentElement.id;
  if(customerToken) {
    var currentDropdown = document.getElementById(event.target.parentElement.children[0].id);
    currentDropdown.style.display = "block";
    var currentSaveButton = document.getElementById(event.target.id);
    currentSaveButton.style.display = "none";
  } else {
    sessionStorage.scopio_origin_uri = window.location.pathname + window.location.search;
    window.location.href = 'https://scop.io/account/login';
  }
};

var saveToNewBoard = function(event) {
  var boardName = document.getElementById("newBoardInput");
  var selectedBoard = event.srcElement.id;
  var currentImg = event.target.parentElement.parentElement.parentElement.parentElement.children[1].id;
  var currentDropdown = document.getElementById(event.target.parentElement.parentElement.id);
  currentDropdown.style.display = "none";
  var boardModal = document.getElementById("boardModal");
  boardModal.style.display = "block";
  $("#newBoardCreation").off('click').on('click', function(event) {
    createNewBoard(boardName.value, currentImg);
    boardModal.style.display = "none";
  });

  boardName.addEventListener('keydown', function(e) {
    var key = e.key || e.keyCode;

    if(key === 'Enter' || key === 13) {
      $("#newBoardCreation").click();
    }
  });

  $("#newBoardInput").focus();
};

var thumbnailOver = function(event) {
  var currentDropdownOptions = document.getElementById(event.target.parentElement.parentElement.children[2].children[0].id);
  currentDropdownOptions.style.display = "none";

  if(event && event.path && event.path[2].childNodes[1]) {
    var selectedImg = document.getElementById(event.path[2].childNodes[1].id);
    if(selectedImg){
      selectedImg.style.display = "block";
    }
  }
}

var thumbnailOut = function(event) {
  var dropdownOptions = document.getElementById('dropdownOptions' + event.target.dataset.id);

  if(dropdownOptions) {
  	dropdownOptions.style.display = "none";
  }
}

var dropdownOver = function(event) {
  var currentDropdownOption = document.getElementById(event.target.parentElement.children[1].id);
  currentDropdownOption.style.display = "block";
}

var createDropdown = function(photoId) {
 	//Dropdown creation
  var addToBoardContainer = document.createElement('div');
  addToBoardContainer.className = "board-dropdown-container";

  var boardDropdown = document.createElement('div');
  boardDropdown.className = "board-dropdown-grid";
  boardDropdown.style.display = "none";
  boardDropdown.id = "boardDropdown" + photoId;
  boardDropdown.addEventListener("mouseover", function(event) {
    var currentDropdownOption = document.getElementById(event.target.parentElement.children[1].id);
    currentDropdownOption.style.display = "block";
  });

  var dropdownTitle = document.createElement('span');
  dropdownTitle.innerText = "Select a Board";

  var dropdownOptions = document.createElement('div');
  dropdownOptions.className = "board-dropdown-options-grid";
  dropdownOptions.id = "dropdownOptions" + photoId;

  var option = document.createElement('div');
  option.innerText = "+ Save to New Board";
  option.className = "board-option-item";
  option.classList.add("board-dropdown-firstchild");
  option.style.fontWeight = "bold";
  dropdownOptions.appendChild(option);
  option.addEventListener("click", saveToNewBoard);

  for(var board of customerBoards){
    var boardOption = createBoardOption(board);

    dropdownOptions.appendChild(boardOption);
  }

  boardDropdown.appendChild(dropdownTitle);
  boardDropdown.appendChild(dropdownOptions);

  //Save to board icon creation
  var addToBoardIcon = document.createElement('img');
  addToBoardIcon.addEventListener("mouseover", function(event) {
    var imgBadgeDownload = document.getElementById(event.target.parentElement.parentElement.children[1].id);
    if(imgBadgeDownload) {
      imgBadgeDownload.style.display = "block";
    }
    var currentSaveButton = document.getElementById(event.target.parentElement.children[1].id);
    if(currentSaveButton) {
      currentSaveButton.style.display = "block";
    }
  });
  /*
  addToBoardIcon.addEventListener("click", function(event) {
    const customerToken = Cookies.get('scopio_customer_token');
    const productId = event.target.parentElement.id;
    if(customerToken) {
      var currentDropdown = document.getElementById(event.target.parentElement.children[0].id);
      currentDropdown.style.display = "block";
      var currentSaveButton = document.getElementById(event.target.id);
      currentSaveButton.style.display = "none";
    } else {
      sessionStorage.scopio_origin_uri = window.location.pathname + window.location.search;
      window.location.href = 'https://scop.io/account/login';
    }
  });
  */
  addToBoardIcon.addEventListener("click", addToBoardAction);
  addToBoardIcon.classList.add("add-grid-button");

  var addIconURL = "//cdn.shopify.com/s/files/1/2395/7099/t/82/assets/add-to-board.svg?v=113490015021010776601654532365";
  addToBoardIcon.setAttribute('src', addIconURL);
  addToBoardIcon.id = "saveButton" + photoId;
  addToBoardIcon.style.display = "none";
  addToBoardIcon.dataset.photoId = photoId;

  var checkContainer = document.createElement('div');
  checkContainer.className = "check-container-icon";
  checkContainer.id = "checkContainerIcon" + photoId;

  var checkIcon = document.createElement('img');
  checkIcon.setAttribute('src', "//cdn.shopify.com/s/files/1/2395/7099/t/82/assets/check-board-icon.svg?v=112273986378112930371654532369");

  checkContainer.appendChild(checkIcon);

  addToBoardContainer.appendChild(boardDropdown);
  addToBoardContainer.appendChild(addToBoardIcon);
  addToBoardContainer.appendChild(checkContainer);

  return addToBoardContainer;
}

var flexRenderSearchResults = function(searchResults, containerId, currentShopifyId) {
  if (divLoadingSearch) {
    divLoadingSearch.style.display = 'none';
  }

  var searchResultsContainer = document.getElementById(containerId);

  var containerWidth = searchResultsContainer.offsetWidth;

  for(var i in searchResults) {
    var searchPhoto = searchResults[i];
  
    if (handlesLoaded.hasOwnProperty(searchPhoto.handle)) {
      continue;
    }

    handlesLoaded[searchPhoto.handle] = true;

    if(currentShopifyId && currentShopifyId === searchPhoto.id) {
      continue;
    }

    var aspectRatio = searchPhoto.image.height / searchPhoto.image.width;

    var imageContainer = document.createElement('div');

    var aGridImageWrapper = document.createElement('a');

    aGridImageWrapper.addEventListener("mouseover", function(event) {
      if (!event.target.parentElement.parentElement.childNodes[2].children[1]) {
        return;
      }

      var currentAddButton = document.getElementById(event.target.parentElement.parentElement.childNodes[2].children[1].id);
      currentAddButton.style.display = "block";
      var checkIcon = document.getElementById('checkContainerIcon' + event.target.parentElement.parentElement.childNodes[1].id);
      checkIcon.style.display = "none";
      var currentDropdownOptions = document.getElementById(event.target.parentElement.parentElement.children[2].children[0].id);
      currentDropdownOptions.style.display = "none";

      if(event.path[2].childNodes[1]){
        var selectedImg = document.getElementById(event.path[2].childNodes[1].id);
      	if(selectedImg){
          selectedImg.style.display = "block";
        }
      }
    });

    aGridImageWrapper.addEventListener("mouseout", function(event) {
      if (!event.target.parentElement.parentElement.childNodes[2].children[1]) {
        return;
      }

      var currentAddButton = document.getElementById(event.target.parentElement.parentElement.childNodes[2].children[1].id);
      currentAddButton.style.display = "none";
      var checkIcon = document.getElementById('checkContainerIcon' + event.target.parentElement.parentElement.childNodes[1].id);
      checkIcon.style.display = "none";
      var dropdownOptions = document.getElementById('dropdownOptions' + event.target.parentElement.parentElement.childNodes[1].id);
      dropdownOptions.style.display = "none";
      //var currentDropDown = document.getElementById(event.target.parentElement.parentElement.childNodes[2].children[0].id);
      //currentDropDown.style.display = "none";

      if(event.path[2].childNodes[1]){
        selectedImg = document.getElementById(event.path[2].childNodes[1].id);
      	if(selectedImg){
          selectedImg.style.display = "none";
        }
      }
    });

    aGridImageWrapper.setAttribute('href', '/products/' + searchPhoto.handle);

    var photoSrc = searchPhoto.image.url;

    var dataSrc = photoSrc;

    var estimatedWidth = heightDesktop / aspectRatio;

    var size = 640;


    //Editorial Badge creation
    var licenseBadge = document.createElement('div');
    licenseBadge.addEventListener("mouseover", function(event) {
      if(mobilecheck() === false) {
        if(event.srcElement.parentElement){
          var selectedIconParent = document.getElementById(event.srcElement.parentElement.attributes[1].nodeValue);
          if(selectedIconParent){
            selectedIconParent.style.display = "block";
          }
      }
      }
    });

    if(searchPhoto.license == "commercial"){
      licenseBadge.classList.add("license-commercial-grid");
	  var licenseBadgeText = document.createTextNode("Commercial");
    } else if (searchPhoto.license == "editorial") {
      licenseBadge.classList.add("license-editorial-grid");
	  var licenseBadgeText = document.createTextNode("Editorial");
    }

    if(licenseBadgeText) {
      licenseBadge.appendChild(licenseBadgeText);
    }


    //Editorial Badge creation
    var licenseBadge = document.createElement('div');
    licenseBadge.addEventListener("mouseover", function(event) {
      if(mobilecheck() === false) {
        if(event.srcElement.parentElement){
          var selectedIconParent = document.getElementById(event.srcElement.parentElement.attributes[1].nodeValue);
          if(selectedIconParent){
            selectedIconParent.style.display = "block";
          }
      }
      }
    });

    if(searchPhoto.license == "commercial"){
      licenseBadge.classList.add("license-commercial-grid");
	  var licenseBadgeText = document.createTextNode("Commercial");
    } else if (searchPhoto.license == "editorial") {
      licenseBadge.classList.add("license-editorial-grid");
	  var licenseBadgeText = document.createTextNode("Editorial");
    }

    if(licenseBadgeText) {
      licenseBadge.appendChild(licenseBadgeText);
    }

    var addToBoardContainer = createDropdown(searchPhoto.id);

    //Download Img icon creation
    var downloadImgIcon = document.createElement('img');
    downloadImgIcon.addEventListener("mouseover", function(event) {
      if(mobilecheck() === false) {
        if(event.srcElement.parentElement){
          var selectedIconParent = document.getElementById(event.srcElement.parentElement.attributes[1].nodeValue);
          if(selectedIconParent){
            selectedIconParent.style.display = "block";
          }
        }
      }
    });
    //Manage the click on download icon
    downloadImgIcon.addEventListener("click", function(event) {
      const customerToken = Cookies.get('scopio_customer_token');
      const productId = event.target.parentElement.id;
      if(customerToken) {
        subscriberDownloadFromSearch(customerToken, productId, searchResults);
      } else {
        sessionStorage.scopio_origin_uri = window.location.pathname + window.location.search;
        window.location.href = 'https://scop.io/account/login';
      }
    });
    downloadImgIcon.classList.add("download-grid-button");
    var downloadIconURL = "//cdn.shopify.com/s/files/1/2395/7099/t/82/assets/download-icon.svg?v=59212245497176742241654532373";
	  downloadImgIcon.setAttribute('src', downloadIconURL);
    //Tools Container created
    var toolsContainer = document.createElement('div');
    toolsContainer.classList.add("img-tools-grid");
    toolsContainer.id = searchPhoto.id;
    toolsContainer.appendChild(licenseBadge);
    //toolsContainer.appendChild(addToBoardIcon);
    toolsContainer.appendChild(downloadImgIcon);


    if(estimatedWidth > size) {
    	size = 740;
    }

    if(photoSrc.indexOf('shopify.com') != -1) {
      if(photoSrc.indexOf('.jpg') != -1) {
        dataSrc = photoSrc.replace('.jpg', '_' + size + 'x.jpg');
      } else if(photoSrc.indexOf('.png') != -1) {
        dataSrc = photoSrc.replace('.png', '_' + size + 'x.png');
      } else if(photoSrc.indexOf('.gif') != -1) {
        dataSrc = photoSrc.replace('.gif', '_' + size + 'x.gif');
      }
    }

    var productImage = document.createElement('img');
    productImage.setAttribute('alt', searchPhoto.title);
    productImage.setAttribute('src', dataSrc);
    productImage.setAttribute('loading', 'lazy');
    productImage.style.display = 'none';

    productImage.dataset.height = searchPhoto.image.height;
    productImage.dataset.width = searchPhoto.image.width;;

    var divImage = document.createElement('div');
    divImage.setAttribute('alt', searchPhoto.title);
    divImage.classList.add('grid-images');
    divImage.style.backgroundImage = 'url(' + dataSrc + ')';
    divImage.style.width = '100%';
    divImage.style.height = '100%';
    divImage.style.backgroundSize = 'contain';

    aGridImageWrapper.appendChild(productImage);
    aGridImageWrapper.appendChild(divImage);
    imageContainer.appendChild(aGridImageWrapper);
    imageContainer.appendChild(toolsContainer);
    imageContainer.appendChild(addToBoardContainer);

    searchResultsContainer.appendChild(imageContainer);
  }

  if(searchResults && searchResults.length > 0 && searchResultsContainer) {
    justify(containerId);

    if (!resizeListenerContainerId) {
      window.addEventListener('resize', justify.bind(null, containerId));
      resizeListenerContainerId = containerId;
    }

    if(searchResultsContainer.style.display !== 'block') {
      searchResultsContainer.style.display = 'block';

      var containerTitle = document.getElementById(containerId + '-title');

      if(containerTitle) {
          containerTitle.style.display = 'block';
      }
    }
  }

  isSearchLoading = false;

  waitForCustomerBoards(updateBoards);
};

var renderPagination = function(data, searchType) {
  var previousPage = data.meta.prev;
  var nextPage = data.meta.next;
  var totalPages = data.meta.total_pages;

  var divLinkPrevious = document.getElementById('link-previous');
  var divCurrentPage = document.getElementById('current-page');
  var divLinkNext = document.getElementById('link-next');

  if(previousPage > 0) {
    var aPrevious = document.createElement('a');
    aPrevious.setAttribute('href', '?page=' + previousPage + '&q=' + scopioSearchQuery + '&t=' + searchType + '&license=' + scopioSearchLicense + '&clevel=' + scopioSearchCLevel);

    var spPrevious = document.createElement('span');
    spPrevious.setAttribute('class', 'icon icon-arrow-left');
    spPrevious.setAttribute('aria-hidden', 'true');

    var txPrevious = document.createTextNode('Back');

    aPrevious.appendChild(spPrevious);
    aPrevious.appendChild(txPrevious);

    divLinkPrevious.appendChild(aPrevious);
  }

  if (totalPages > 1) {
    var txCurrent = document.createTextNode(scopioSearchPage);
    divCurrentPage.appendChild(txCurrent);
  }

  if (nextPage > 0) {
    var aNext = document.createElement('a');
    aNext.setAttribute('href', '?page=' + nextPage + '&q=' + scopioSearchQuery + '&t=' + searchType + '&license=' + scopioSearchLicense + '&clevel=' + scopioSearchCLevel);

    var spNext = document.createElement('span');
    spNext.setAttribute('class', 'icon icon-arrow-right');
    spNext.setAttribute('aria-hidden', 'true');

    var txNext = document.createTextNode('Next');

    aNext.appendChild(txNext);
    aNext.appendChild(spNext);

    divLinkNext.appendChild(aNext)
  }
};

var registerSearchLog = function(searchData, result_type,total_results) {
  if (Cookies.get('scopio_customer_token')) {
    var customerId = Cookies.get('scopio_customer_id');
    var event = new CustomEvent("customer_log_acquired", {
        detail: {
          log_type: 'customer_log',
          message: 'Search performed',
          data: {
            page: location.href,
            searchData: searchData,
            result_type: result_type,
            total_results: total_results,
            customer_data: {
              shopify_id: customerId,
            },
          }
        }
      });
    document.dispatchEvent(event);
  }
}

var getImageUrl = function(photo) {
  if (mobilecheck() === true) {
    heightDesktop = 200;
    maxRowHeight = 320;
  } else {
    heightDesktop = 300;
    maxRowHeight = 480;
  }
  var size =  300;
  var dataSrc = photo.image.url;
  var photoSrc = photo.image.url;
  if (photoSrc.indexOf('.jpg') != -1) {
    dataSrc = photoSrc.replace('.jpg', '_' + size + 'x.jpg');
  } else if (photoSrc.indexOf('.png') != -1) {
    dataSrc = photoSrc.replace('.png', '_' + size + 'x.png');
  } else if (photoSrc.indexOf('.gif') != -1) {
    dataSrc = photoSrc.replace('.gif', '_' + size + 'x.gif');
  }
  return dataSrc;
}

var getPhotographerPhotogrid = function (photos, firstName, lastName) {
  // var aspectRatio = searchPhoto.image.height / searchPhoto.image.width;
  var link = document.createElement('a');
  link.href = `/collections/vendors?q=${firstName.trim()}+${lastName.trim()}`;
  var gridContainer = document.createElement('div');
  gridContainer.classList.add('photographer-grid');
  for (var i = 0; i < 6 && i < photos.length; i++) {
    var img = document.createElement('img');
    img.src = photos[i].image.url;
    img.title = photos[i].title;
    img.alt = photos[i].title;
    img.id = photos[i].id;
    gridContainer.appendChild(img);
    img.loading = 'lazy';
  }
  link.appendChild(gridContainer);
  return link;
}

var createShareButton = function (photographer) {
  var shareContainer = document.createElement('div');
  shareContainer.classList.add('tooltip');

  var shareButton = document.createElement('button');
  shareButton.innerHTML = 'Share';
  shareButton.classList.add('share-button');
  shareButton.dataset.shareId = photographer.id;
  shareButton.addEventListener('click', function (event) {
    if (document.getElementById(event.target.dataset.shareId).style.display === 'none') {
      document.getElementById(event.target.dataset.shareId).style.display = 'block';
    } else {
      document.getElementById(event.target.dataset.shareId).style.display = 'none';
    }
  })
  shareContainer.appendChild(shareButton);
  var tooltipTextId = `tooltiptext-${photographer.id}`
  var dropDownShareContainer = document.createElement('div');
  dropDownShareContainer.classList.add('dropdown-content');
  dropDownShareContainer.id = photographer.id;
  var copiedAlert = document.createElement('span');
  copiedAlert.classList.add('tooltiptext');
  copiedAlert.id = tooltipTextId;
  copiedAlert.style.display = 'none';
  copiedAlert.innerHTML = 'Link Copied'
  dropDownShareContainer.appendChild(copiedAlert);
  var copyShareLinkButton = document.createElement('button');
  copyShareLinkButton.dataset.alertId = tooltipTextId;
  copyShareLinkButton.addEventListener('click', function (event) {
    navigator.clipboard.writeText(`https://scop.io/collections/vendors?q=${photographer.firstName.trim()}+${photographer.lastName.trim()}`);
    document.getElementById(event.target.dataset.alertId).style.display = 'block';
    var timeout = setTimeout(function () { document.getElementById(event.target.dataset.alertId).style.display = 'none'; clearTimeout(timeout) }, 2000);
  });
  copyShareLinkButton.innerHTML = 'Copy Link to profile';
  dropDownShareContainer.appendChild(copyShareLinkButton);
  shareContainer.appendChild(dropDownShareContainer);
  return shareContainer;
}

var getPhotographerInformation = function (photographer) {
  var photographerInformationContainer = document.createElement('div');
  photographerInformationContainer.classList.add('photographer-information');

  var titleLink = document.createElement('a');
  titleLink.href = `/collections/vendors?q=${photographer.firstName.trim()}+${photographer.lastName.trim()}`;
  var title = document.createElement('h4');
  title.innerHTML = photographer.fullName;
  titleLink.appendChild(title)
  photographerInformationContainer.appendChild(titleLink);

  var locationContainer = document.createElement('div');
  locationContainer.classList.add('photographer-location');
  var locationIcon = document.createElement('img');
  locationIcon.src = "//cdn.shopify.com/s/files/1/2395/7099/t/82/assets/location_purple.svg?v=119384865321117681121654532396";
  locationIcon.classList.add('photographer-location-icon');
  var location = document.createElement('span');
  var locationArray = [photographer.city, photographer.country].filter(value => value ? true : false);
  location.innerHTML = locationArray.join(', ');
  locationContainer.appendChild(locationIcon);
  locationContainer.appendChild(location);
  photographerInformationContainer.appendChild(locationContainer);
  var actionContainer = document.createElement('div');

  if (photographer.skills && photographer.skills.length) {
    var skillsContainer = document.createElement('div');
    skillsContainer.classList.add('photographer-location');

    var spanSkills = document.createElement('span');

    var txSkills = document.createTextNode(photographer.skills.join(', '));
    spanSkills.appendChild(txSkills);

    skillsContainer.appendChild(spanSkills);

    photographerInformationContainer.appendChild(skillsContainer);
  }

  var hireButton = document.createElement('button');
  hireButton.innerHTML = 'Hire';
  hireButton.classList.add('hire-button');
  hireButton.addEventListener('click', function (event) { window.location.href = '/pages/hire-artists' })
  actionContainer.appendChild(createShareButton(photographer));
  actionContainer.appendChild(hireButton);
  actionContainer.classList.add('photographer-information__action-container');
  photographerInformationContainer.appendChild(actionContainer);
  return photographerInformationContainer;
}

var getPhotographerInformationMobile = function (photographer) {
  var photographerInformationContainer = document.createElement('div');
  photographerInformationContainer.classList.add('photographer-information');

  var photographerInformation = document.createElement('div');
  photographerInformation.classList.add('photographer-information-group');
  var titleLink = document.createElement('a');
  titleLink.href = `/collections/vendors?q=${photographer.firstName.trim()}+${photographer.lastName.trim()}`;
  var title = document.createElement('h4');
  title.innerHTML = photographer.fullName;
  titleLink.appendChild(title)
  photographerInformation.appendChild(titleLink);

  var locationContainer = document.createElement('div');
  locationContainer.classList.add('photographer-location');
  var locationIcon = document.createElement('img');
  locationIcon.src = "//cdn.shopify.com/s/files/1/2395/7099/t/82/assets/location_purple.svg?v=119384865321117681121654532396";
  locationIcon.classList.add('photographer-location-icon');
  var location = document.createElement('span');
  var locationArray = [photographer.city, photographer.country].filter(value => value ? true : false);
  location.innerHTML = locationArray.join(', ');
  locationContainer.appendChild(locationIcon);
  locationContainer.appendChild(location);
  photographerInformation.appendChild(locationContainer);
  var actionContainer = document.createElement('div');

  if (photographer.skills && photographer.skills.length) {
    var skillsContainer = document.createElement('div');
    skillsContainer.classList.add('photographer-location');

    var spanSkills = document.createElement('span');

    var txSkills = document.createTextNode(photographer.skills.join(', '));
    spanSkills.appendChild(txSkills);

    skillsContainer.appendChild(spanSkills);

    photographerInformation.appendChild(skillsContainer);
  }

  var hireButton = document.createElement('button');
  hireButton.innerHTML = 'Hire';
  hireButton.classList.add('hire-button');
  hireButton.addEventListener('click', function (event) {
    window.location.href = '/pages/hire-artists'
  })
  actionContainer.appendChild(createShareButton(photographer));
  actionContainer.appendChild(hireButton);
  actionContainer.classList.add('photographer-information__action-container');
  photographerInformationContainer.appendChild(photographerInformation);
  photographerInformationContainer.appendChild(actionContainer);
  return photographerInformationContainer;
}

var renderPhotographersResult = function (searchResults, containerId) {
  divLoadingSearch.style.display = 'none';

  var searchResultsContainer = document.getElementById(containerId);

  for (var i in searchResults) {
    var searchPhotographer = searchResults[i];

    if (handlesLoaded.hasOwnProperty(searchPhotographer.handle)) {
      continue;
    }

    handlesLoaded[searchPhotographer.handle] = true;

    var imageContainer = document.createElement('div');
    imageContainer.classList.add('photographer-search-result-container');
    var photographerContainer = document.createElement('div');
    photographerContainer.classList.add('photographer-search-result');

    if (mobilecheck() === true) {
      photographerContainer.appendChild(getPhotographerInformationMobile(searchPhotographer));
      photographerContainer.appendChild(getPhotographerPhotogrid(searchPhotographer.photos, searchPhotographer.firstName, searchPhotographer.lastName));
    } else {
      photographerContainer.appendChild(getPhotographerPhotogrid(searchPhotographer.photos, searchPhotographer.firstName, searchPhotographer.lastName));
      photographerContainer.appendChild(getPhotographerInformation(searchPhotographer));
    }
    imageContainer.appendChild(photographerContainer);
    searchResultsContainer.appendChild(imageContainer);
  }
}

var runStoriesPeopleSearch = function (searchData, containerId, alternativeSearch, disablePagination, callback, currentShopifyId) {
  if (searchData) {
    isSearchLoading = true;

    if (!searchData.page) {
      searchData.page = scopioSearchPage;
    }

    if (!searchData.page_size) {
      searchData.page_size = scopioSearchPageSize;
    }

    lastSearchParams = {
      searchData: searchData,
      containerId: containerId,
      alternativeSearch: alternativeSearch,
      disablePagination: disablePagination,
      callback: callback,
      currentShopifyId: currentShopifyId,
    };

    searchData.scrollId = Object.keys(idsLoaded).length;
    // searchData.q = encodeURIComponent(searchData.q);

    $.ajax({
      method: 'GET',
      url: scopioStoriesPeopleSearchUrl,
      dataType: 'json',
      data: searchData,
      /*
      data: {
        q: scopioSearchQuery,
        search_type: searchType,
        license: scopioSearchLicense,
        page: scopioSearchPage,
        page_size: scopioSearchPageSize,
      }
      */
    }).done(function (containerId, searchType, pageSize, disablePagination, callback, currentShopifyId, data) {


      var searchResults = data.photographers;
      scrollId = data.scrollId;
      if (searchResults && searchResults.length > 0) {
        totalSearchResults += searchResults.length;
        registerSearchLog(searchData, 'search-results', totalSearchResults);

        switch (searchType) {
          case 'people':
            renderPhotographersResult(searchResults, containerId, currentShopifyId);
            break;
          case 'stories':
            break;
          default:
            return;
        }
        /*
        if (!disablePagination) {
          renderPagination(data, searchType);
        }
        */
      } else if (!idsLoaded || Object.keys(idsLoaded).length == 0){
        registerSearchLog(searchData, 'no-results', 0);
        if (noExactMatches && noExactMatches.style) {
          divLoadingSearch.style.display = 'none';
          noExactMatches.style.display = 'block';
        }

      }
      isSearchLoading = false;
      if (callback) {
        callback();
      }

    }.bind(null, containerId, searchType, searchData.page_size, disablePagination, callback, currentShopifyId));
  }
};


var runSearch = function(searchData, containerId, alternativeSearch, disablePagination, callback, currentShopifyId) {
  if(searchData) {
    isSearchLoading = true;

    if(!searchData.page) {
    	searchData.page = scopioSearchPage;
    }

    if(!searchData.page_size) {
    	searchData.page_size = scopioSearchPageSize;
    }

    if(!searchData.clevel) {
    	searchData.clevel = scopioSearchCLevel;
    }

    lastSearchParams = {
      searchData: searchData,
      containerId: containerId,
      alternativeSearch: alternativeSearch,
      disablePagination: disablePagination,
      callback: callback,
      currentShopifyId: currentShopifyId,
    };

    // searchData.q = encodeURIComponent(searchData.q);

    $.ajax({
      method: 'GET',
      url: scopioSearchUrl,
      dataType: 'json',
      data: searchData,
      /*
      data: {
        q: scopioSearchQuery,
        search_type: searchType,
        license: scopioSearchLicense,
        page: scopioSearchPage,
        page_size: scopioSearchPageSize,
      }
      */
    }).done(function(containerId, alternativeSearch, searchType, pageSize, disablePagination, callback, currentShopifyId, data) {
      if(data.meta) {
        if(data.meta.clevel) {
          scopioSearchCLevel = data.meta.clevel;
        }

        var relatedSearches = divRelatedSearches;

        if(relatedSearches && data.meta.related_searches) {
          if(!relatedSearches.hasChildNodes()) {
            while(relatedSearches.hasChildNodes() === true) {
              relatedSearches.removeChild(relatedSearches.firstChild);
            }

            data.meta.related_searches.forEach(function(relatedSearch) {
              if (relatedSearch === scopioSearchQuery) {
              	return;
              }

              var itemLink = document.createElement('a');
              itemLink.setAttribute('href', '/search?q=' + encodeURI(relatedSearch) + '&license=' + scopioSearchLicense + '&search_type=images');
              itemLink.setAttribute('class', 'related-search');
              itemLink.addEventListener('click', relatedSearchHandler);

              var relatedSearchText = relatedSearch.replaceAll('+', ' ');

              var itemText = document.createTextNode(relatedSearchText);

              itemLink.appendChild(itemText);

              relatedSearches.appendChild(itemLink);
            });

            var relatedSearchesLoadedEvent = new CustomEvent("related_searches_loaded");
            document.dispatchEvent(relatedSearchesLoadedEvent);
          }
        }
      }

      var searchResults = data.data;
      var searchMeta = data.meta;

      // TODO: Display  No Results when No Results...

      if(scopioSearchType !== 'partial' && !alternativeSearch && totalSearchResults === 0 && (!data || !searchResults || searchResults.length === 0) && ((scopioSearchLicense === 'editorial' && editorialSearchNoResults) || (scopioSearchLicense !== 'editorial' && searchNoResults))) {
        if(scopioSearchLicense === 'editorial') {
          registerSearchLog(searchData, 'show-editorial-collection', 0);
          loadEditorialCollection();
        } else if (searchNoResults) {
          registerSearchLog(searchData, 'no-results', 0);
          divLoadingSearch.style.display = 'none';
          searchNoResults.style.display = 'block';
        }

        isSearchLoading = false;

        return;
      }

      if(searchResults && searchResults.length > 0) {
        totalSearchResults += searchResults.length;
        registerSearchLog(searchData, 'search-results', totalSearchResults);

        flexRenderSearchResults(searchResults, containerId, currentShopifyId);

        // flexRenderSearchResults(searchResults, containerId, currentShopifyId);
/*
        getUserBoards().then(res =>{
          var customerBoards = res.data;
          flexRenderSearchResults(searchResults, containerId, customerBoards, currentShopifyId);
        }).catch(err => {
          var customerBoards = [];
          flexRenderSearchResults(searchResults, containerId, customerBoards, currentShopifyId);
        });
*/
/*
        if(!disablePagination) {
          renderPagination(data, searchType);
        }
*/
      } else if(!alternativeSearch) {
        /*
        if(scopioSearchLicense === 'editorial') {
          loadEditorialCollection();
        } else if (searchNoResults) {
          divLoadingSearch.style.display = 'none';
          searchNoResults.style.display = 'block';
        }
        */
        // divLoadingSearch.style.display = 'none';

        isSearchLoading = false;
      } else {
        registerSearchLog(searchData, 'no-results', 0);
        if(totalSearchResults === 0 && noExactMatches && noExactMatches.style) {
          divLoadingSearch.style.display = 'none';
          noExactMatches.style.display = 'block';
          recreateSearchResults();
        }
        isSearchLoading = false;
      }

      if(alternativeSearch && (!searchResults || !searchMeta || !searchMeta.next || searchMeta.next === -1 )) {
        if(unableToFind && unableToFind.style) {
          unableToFind.style.display = 'block';
        }
        isSearchLoading = false;
        alternativeSearch();
      }

      if(callback) {
        callback();
      }

    }.bind(null, containerId, alternativeSearch, searchData.search_type, searchData.page_size, disablePagination, callback, currentShopifyId));
  }
};

var shopifyCollectionFallback = function(collectionHandle, containerId, page, pageSize, callback, isVendor) {
  isSearchLoading = true;

  var url = '/collections/';

  if(!lastSearchParams) {
    lastSearchParams = {
      searchData: {
        handle: collectionHandle,
        page_size: pageSize,
        page: page,
        clevel: scopioSearchCLevel,
      },
      containerId: containerId,
      callback: callback,
      isFallback: true,
      isVendor: false,
    };
  }
  if(isVendor === true) {
    url += 'vendors?q=' + collectionHandle + '&view=json';
    lastSearchParams.isVendor = true;
  } else {
    url += collectionHandle + '?view=json';
  }

  if(pageSize === 50) {
    url += '-50';
  }

  if(lastSearchParams.searchData.page > page) {
    page = lastSearchParams.searchData.page;
  }

  if(page > 1) {
    url += '&page=' + page
  }

  fetch(url)
  .then(response => response.json())
  .then(function(containerId, callback, data) {
    var searchResults = data.data;

    flexRenderSearchResults(searchResults, containerId);

    if(callback) {
      callback();
    }
    isSearchLoading = false;
  }.bind(null, containerId, callback))
  .catch(error => {
    isSearchLoading = false;
    console.error('Collection loading error: ', error);
  });
}

var runSearchQuery = function(searchType, containerId, alternativeSearch, disablePagination) {
  runSearch({
    q: scopioSearchQuery,
    search_type: searchType,
    license: scopioSearchLicense,
    country: locationCountry || selectedCountry,
    city: locationCity || selectedCity,
    state: locationState,
    orientation: selectedOrientation,
    clevel: scopioSearchCLevel,
  }, containerId, alternativeSearch, disablePagination);
}

var runSearchPhotographer = function(photographer, containerId, alternativeSearch) {
  var data = {
    photographer: photographer,
  };

  runSearch(data, containerId, alternativeSearch, true);
}

var runSearchCollection = function(collectionId, collectionHandle, containerId, pageSize, page, disablePagination, callback, alternativeSearch) {
  var data = {
    collection_id: collectionId,
    collection_handle: collectionHandle,
    page_size: pageSize,
    page: page,
  };

  runSearch(data, containerId, alternativeSearch, disablePagination, callback);
}

var clearContainer = function(containerId) {
  var container = document.getElementById(containerId);

  while(container.hasChildNodes() === true) {
  	container.removeChild(container.firstChild);
  }
}

var loadEditorialCollection = function() {
  if(typeof loadScopioCollection === 'function') {
    loadScopioCollection('editorial', editorialCollectionContainer, function(editorialSearchNoResults) {
      editorialSearchNoResults.style.display = 'block';
      isSearchLoading = false;
    }.bind(null, editorialSearchNoResults));
  }
}

var runHomepageCollection = function(collection, containerId, pageSize, page, callback, alternativeSearch) {
  if(page < 2) {
  	clearContainer(containerId);
  }

  isHomepage = true;

  runSearchCollection(collection, collection, containerId, pageSize, page, true, callback, alternativeSearch);
}

var runSimilarImagesSearch = function(query, currentShopifyId, type) {
  isProductPage = true;
  function displaySimilar() {
    document.getElementById('similar-images').style.display = 'block';
  }

  if(!scopioSearchCLevel) {
    scopioSearchCLevel = 0;
  }

  runSearch(
    {
      q: query,
      search_type: 'exact',
      license: 'all',
      page_size: 13,
      current_shopify_id: currentShopifyId,
      clevel: scopioSearchCLevel,
    },
    'related-products',
    function alternativeSearch(query, currentShopifyId, displaySimilar) {
      if(!scopioSearchCLevel) {
        scopioSearchCLevel = 1;
      }

      runSearch(
        {
          q: query,
          search_type: 'partial',
          license: 'all',
          page_size: 12,
      	  current_shopify_id: currentShopifyId,
          clevel: scopioSearchCLevel,
        },
        'related-products',
        null,
        true,
        displaySimilar,
    	currentShopifyId
      );
    }.bind(null, query, currentShopifyId, displaySimilar),
    true,
    displaySimilar,
    currentShopifyId
  );
}

var loadSearch = function(disablePagination) {
  if (searchType === 'images') {
    if(scopioSearchQuery) {
      if(scopioSearchType === 'partial') {
        if(!scopioSearchCLevel) {
          scopioSearchCLevel = 1;
        }

        runSearchQuery('partial', 'scopio-additional-search-results', null, disablePagination);
      } else if(scopioSearchType === 'exact') {
        runSearchQuery('exact', 'scopio-search-results', function() {}, disablePagination);
      } else {
        runSearchQuery('exact', 'scopio-search-results', function() {
          if(!scopioSearchCLevel) {
            scopioSearchCLevel = 1;
          }

          runSearchQuery('partial', 'scopio-additional-search-results');
        }, disablePagination);
      }

      switch(scopioSearchLicense) {
        case 'all':
          $(labelLicense).html('Filter');
          break;
        case 'editorial':
          $(labelLicense).html('Editorial');
          break;
        case 'commercial':
          $(labelLicense).html('Commercial');
          break;
        default:
          $(labelLicense).html('Filter');
      }
    } else {
      scopioSearchType = 'featured';
      runSearchQuery('featured', 'scopio-search-results', function() {}, disablePagination);
    }
  } else if (searchType === 'stories' || searchType === 'people') {
    document.getElementById('search_type').value = searchType;
    runStoriesPeopleSearch({
      query: scopioSearchQuery,
      type: searchType,
      country: locationCountry || selectedCountry,
      city: locationCity || selectedCity,
      state: locationState,
      gender: selectedGender,
      ethnicities: selectedEthnicities,
      skills: selectedSkills,
    }, 'scopio-people-search-results', () => {}, disablePagination);
  }
}

var offset = function(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
};

var waitForCustomerBoards = function (callback) {
  if(customerBoardsLoaded === true) {
    callback();
    return;
  }

  setTimeout(waitForCustomerBoards.bind(this, callback), 50);
};

var changeCountry = function(event) {
  if (!autocompleteCity || !autocompleteCityMob) {
    return;
  }

  var targetField = event.target;
  var country = targetField.value;

  var fromPlace = false;

  if (event.detail && event.detail.from_place === true) {
    fromPlace = true;
  }

  countryField.value = country;
  countryFieldMob.value = country;

  autocompleteCity.setComponentRestrictions({
    country: country,
  });

  autocompleteCityMob.setComponentRestrictions({
    country: country,
  });

  if (!fromPlace) {
    clearCity();
  }
/*
  if (country !== selectedCountry && country !== locationCountry) {
    cityField.value = '';
    cityFieldMob.value = '';
  }
*/
};

var placeChangeHandler = function(field) {
  if (!autocompleteCity || !autocompleteCityMob) {
    return;
  }

  var place = null;

  if (field === 'city_mob') {
    place = autocompleteCityMob.getPlace();
  } else {
    place = autocompleteCity.getPlace();
  }

  if (!place || !place.address_components) {
    return;
  }

  placeRetrieved = true;

  var componentForm = {
    locality: "long_name",
    colloquial_area: "long_name",
    administrative_area_level_1: "long_name",
    administrative_area_level_2: "long_name",
    administrative_area_level_3: "long_name",
    postal_town: "long_name",
    sublocality_level_1: "long_name",
    country: "short_name",
  };

  var results = {};

  for (const component of place.address_components) {
    var addressType = component.types[0];

    if (componentForm[addressType]) {
      var val = component[componentForm[addressType]];
      results[addressType] = val;

      if (addressType === 'country') {
        results['countryName'] = component['long_name'];
        results['countryCode'] = component['short_name'];
      }
    }
  }

  locationCity =
    results.sublocality_level_1 ||
    results.postal_town ||
    results.locality ||
    results.colloquial_area ||
    results.administrative_area_level_3;
  locationState = results.administrative_area_level_1 || results.administrative_area_level_2;
  locationCountry = results.countryCode;

  countryField.value = locationCountry;
  countryFieldMob.value = locationCountry;
  countryField.dispatchEvent(new CustomEvent('change', {
    detail: {
      from_place: true,
    }
  }));

  if (field === 'city_mob') {
    cityField.value = cityFieldMob.value;
  } else {
    cityFieldMob.value = cityField.value;
  }
};

var clearUrlFilters = function(url) {
  url.searchParams.delete('country');
  url.searchParams.delete('city');
  url.searchParams.delete('location_city');
  url.searchParams.delete('location_state');
  url.searchParams.delete('location_country');
  url.searchParams.delete('gender');
  url.searchParams.delete('ethnicity');
  url.searchParams.delete('skills');
  url.searchParams.delete('orientation');
};

var clearUrlParams = function(url) {
  url.searchParams.delete('q');
  url.searchParams.delete('search_type');
  url.searchParams.delete('license');

  clearUrlFilters(url);
};

var searchSubmissionHandler = function(event) {
  if (event) {
    event.preventDefault();
  }

  searchBarInput.blur();

  var url = new URL(window.location);

  if (url.pathname !== '/search') {
    url.pathname = '/search';
  }

  var titleSuffix = ' on Scopio | Authentic Photo Library';
  var titlePrefix = '';
  var capitalizedSearch = '';

  if (searchBarInput.value) {
    capitalizedSearch = searchBarInput.value.charAt(0).toUpperCase() + searchBarInput.value.slice(1);
  }

  clearUrlParams(url);

  searchType = searchTypeField.value;

  url.searchParams.set('q', searchBarInput.value);
  url.searchParams.set('search_type', searchType);

  if (countryField.value || countryFieldMob.value) {
    url.searchParams.set('country', countryField.value || countryFieldMob.value);
  }

  if (cityField.value) {
    url.searchParams.set('city', cityField.value);
  }

  if (locationCity) {
    url.searchParams.set('location_city', locationCity);
  }

  if (locationState) {
    url.searchParams.set('location_state', locationState);
  }

  if (locationCountry) {
    url.searchParams.set('location_country', locationCountry);
  }

  if (searchType === 'images') {
    var existingLicenses = {};
    var existingOrientations = {};

    searchForm.querySelectorAll(`input[type="radio"][data-type="license"]:checked`).forEach((license) => {
      if (license.value in existingLicenses) {
        return;
      }

      existingLicenses[license.value] = true;

      url.searchParams.set('license', license.value);
    });

    searchForm.querySelectorAll(`input[type="radio"][data-type="orientation"]:checked`).forEach((orientation) => {
      if (orientation.value in existingOrientations) {
        return;
      }

      existingOrientations[orientation.value] = true;

      url.searchParams.set('orientation', orientation.value);
    });

    if (capitalizedSearch) {
      titlePrefix = capitalizedSearch + ' images';
    } else {
      titlePrefix = 'Images Search';
    }
  } else if (searchType === 'people') {
    var existingGenders = {};
    var existingEthnicities = {};
    var existingSkills = {};

    searchForm.querySelectorAll(`input[type="radio"][data-type="gender"]:checked`).forEach((gender) => {
      if (gender.value in existingGenders) {
        return;
      }

      existingGenders[gender.value] = true;

      url.searchParams.set('gender', gender.value);
    });

    searchForm.querySelectorAll(`input[type="checkbox"][data-type="ethnicity"]:checked`).forEach((ethnicity) => {
      if (ethnicity.value in existingEthnicities) {
        return;
      }

      existingEthnicities[ethnicity.value] = true;

      url.searchParams.append('ethnicity', ethnicity.value);
    });

    searchForm.querySelectorAll(`input[type="checkbox"][data-type="skills"]:checked`).forEach((skill) => {
      if (skill.value in existingSkills) {
        return;
      }

      existingSkills[skill.value] = true;

      url.searchParams.append('skills', skill.value);
    });

    if (capitalizedSearch) {
      titlePrefix = capitalizedSearch + ' artists';
    } else {
      titlePrefix = 'Artists Search';
    }
  }

  var newTitle = titlePrefix + titleSuffix;

  window.history.pushState({}, newTitle, url);

  stateChanged = true;

  reloadSearch();

  document.title = newTitle;

  registerPageview(url);
};

var registerPageview = function(url) {
  if (!url) {
    url = new URL(window.location);
  }

  dataLayer.push({
    event: 'search_pageview',
    page: url.pathname + url.search.toString(),
    title: document.title,
  });
};

var hideMessages = function() {
  if (noExactMatches && noExactMatches.style) {
    noExactMatches.style.display = 'none';
  }
}

var clearResults = function() {
  hideMessages();
  clearContainer(divAdditionalSearchResults.id);
  clearContainer(divSearchResults.id);
  clearContainer(divRelatedSearches.id);
  clearContainer(divPeopleSearchResults.id);

  if (aCarouselNext) {
    aCarouselNext.style.display = 'none';
  }
};

var scrollTop = function() {
  window.scroll({
    top: 0,
    behavior: 'smooth',
  });
}

var reloadSearch = function(isNewPageview) {
  closeFilterDropdowns();
  clearFormFilters();
  refreshParameters();
  clearResults();
  recreateSearchResults();
  configSearchType();
  loadSearch(true);
  scrollTop();

  if (isNewPageview) {
    registerPageview();
  }
};

var closeFilterDropdowns = function() {
  document.querySelectorAll('div.dropdown-content-filter--wrapper').forEach((dropdown) => {
    if (dropdown.classList.contains('show')) {
      dropdown.classList.remove('show');
    }
  });

  document.querySelectorAll('div.content-filter--wrapper-mob').forEach((dropdown) => {
    if (dropdown.classList.contains('show-mob')) {
      dropdown.classList.remove('show-mob');
    }
  });
};

var submitSearchForm = function() {
  searchForm.dispatchEvent(new Event('submit'));
}

var clearChecks = function(fieldName) {
  searchForm.querySelectorAll(`input[data-type="${fieldName}"]:checked`).forEach((field) => {
    field.checked = false;
  });
  switch (fieldName) {
    case 'gender':
    case 'ethnicity':
    case 'skills':
    case 'license':
    case 'orientation':
      document.getElementById('lbcount' + fieldName).textContent = '';
      break;
  };
}

var clearCity = function() {
  cityField.value = '';
  cityFieldMob.value = '';
  locationCity = null;
  locationState = null;
  locationCountry = null;
};

var clearCountry = function() {
  countryField.value = '';
  countryFieldMob.value = '';

  clearCity();

  autocompleteCity.setComponentRestrictions(null);

  autocompleteCityMob.setComponentRestrictions(null);
  document.getElementById('lbcountcountry').textContent = '';
}

var clearFormFilters = function() {
  clearCountry();
  clearChecks('gender');
  clearChecks('ethnicity');
  clearChecks('skills');
  clearChecks('license');
  clearChecks('orientation');
};

var clearFilterAction = function(event) {
  var element = event.target;
  var clearTarget = element.dataset.target;

  switch (clearTarget) {
    case 'gender':
    case 'ethnicity':
    case 'skills':
    case 'license':
    case 'orientation':
      clearChecks(clearTarget);
      break;
    case 'country':
      clearCountry();
      break;
  }
};

var clearMobFilters = function() {
  clearFormFilters();
};

var popstateHandler = function() {
  if (stateChanged === true) {
    setTimeout(reloadSearch.bind(this, true), 0);
  }
}

var relatedSearchHandler = function(event) {
  event.preventDefault();

  var relatedSearchLink = event.target;

  searchBarInput.value = relatedSearchLink.textContent;

  submitSearchForm();
};

var syncDuplicatedFilter = function(event) {
  var targetField = event.target;

  searchForm.querySelectorAll(`input[data-type="${targetField.dataset.type}"]`).forEach((field) => {
    if (field.id === targetField.id) {
      return;
    }

    if (field.getAttribute('type') === 'radio' || field.getAttribute('type') === 'checkbox') {
      var isChecked = targetField.checked;

      if (field.value === targetField.value) {
        field.checked = isChecked;
      }
    } else {
      field.value = targetField.value;
    }
  });
};

var syncCityFilter = function(event) {
  syncDuplicatedFilter(event);

  cityChanged = true;
  placeRetrieved = false;

  locationCity = null;
  locationState = null;
  locationCountry = null;
};

var subscriberDownloadFromSearch = function(customerToken, productId, searchResults, photographerName) {
  if(!photographerName) {
    var currentSelection = searchResults.filter(p => p.id == productId)[0];
    photographerName = currentSelection.photographer_name;
  }
  var downloadData = {
    product_id: productId,
  };

  var downloadHeaders = {
    'Authorization': 'Bearer ' + customerToken,
  };

  $.ajax({
    method: 'POST',
    url: 'https://api.scop.io/me/downloads',
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    data: JSON.stringify(downloadData),
    headers: downloadHeaders,
  }).done(function (_data) {
    var downloadUrl = _data.data.download_url;

    window.location.href = downloadUrl;

    //Open Credits Modal
    $(".credits-modal-bottom").attr('style','display:block !important; transition:0.7s ease');
    $("#vendorCredits").text(photographerName);
    $("#vendorCredits").attr("href", "https://scop.io/collections/vendors?q=" + photographerName.replace(/ /g, '+'));
  }).fail(function (_err) {
    console.error(_err);

    if(_err.status === 429) {
      var response = _err.responseJSON;

      var errorMessage = response.message;

      if(!errorMessage) {
        errorMessage = 'You’ve reached your download limit for today, try tomorrow!';
      }

      displayError(errorMessage);

      
    } else {
      // customAddToCart();
      
      document.location.href = '/account?view=subscription';
    }
  });
};

var customAddToCart = function() {
  var tempId =  $('.variation-button label.varactive').attr('relid');
  var removeid = $('.variation-button label.varinactive').attr('relid');
  console.log('removed'+removeid);
  var tempQty = 1;
  console.log('temp'+tempId);

  //$(this).closest('form').find('button').trigger('click');
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity='+tempQty+'&id='+tempId+'',
    dataType: 'json',
    beforeSend: function() {
      $('#AddToCartText-product-template').html('Adding..');
    },
    success: function(line_item) {
      console.log(line_item);
      console.log('added success');
      jQuery.post('/cart/update.js', 'updates['+tempId+']=1');
      setTimeout(function(){ $('.js-drawer-open-right').trigger('click'); }, 2000);
    },
    error: function(xhr, status, error) {
      console.log(xhr.responseText + status + error);

    }
  };
  $.ajax(params);
  setTimeout(function(){
    jQuery.post('/cart/update.js', 'updates['+removeid+']=0');

  }, 1000);
};

// Function that copies the credits to the clipboard
var closeCreditsModal = function(){
  $(".credits-modal-bottom").attr('style','display:none !important; transition:0.7s ease');
}

// Function that opens the embed modal
var openEmbedModal = function() {
  var currentVendor = document.getElementById("vendorCredits").innerHTML;
  $("#vendorEmbed").text(currentVendor);
  $("#vendorEmbed").attr("href", "https://scop.io/collections/vendors?q=" + currentVendor.replace(/ /g, '+'));
  var embedPreCode = $("#embedPreCode").html();
  var codeContainer = document.getElementById("codeContainer");
  codeContainer.innerHTML = embedPreCode;
  $("#embedModal").attr('style','display:block !important; transition:0.7s ease');
}

// Function that closes the embed modal
var closeEmbedModal = function(){
  $("#embedModal").attr('style','display:none !important; transition:0.7s ease');
}

// Function that copies the credits to the clipboard
var copyCredits = function(){
  var elm = document.getElementById("creditsContent");
  // for Internet Explorer
  if(document.body.createTextRange) {
    var range = document.body.createTextRange();
    range.moveToElementText(elm);
    range.select();
    document.execCommand("Copy");
  }
  else if(window.getSelection) {
    // other browsers
    var selection = window.getSelection();
    var range = document.createRange();
    range.selectNodeContents(elm);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("Copy");
  }
}

// Function that copies the embed code to the clipboard
var copyEmbedCode = function(){
  var elm = document.getElementById("codeContainer");
  // for Internet Explorer
  if(document.body.createTextRange) {
    var range = document.body.createTextRange();
    range.moveToElementText(elm);
    range.select();
    document.execCommand("Copy");
  }
  else if(window.getSelection) {
    // other browsers
    var selection = window.getSelection();
    var range = document.createRange();
    range.selectNodeContents(elm);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("Copy");
  }
}

// Function that retrieve user boards

var getUserBoards = function(){
  const customerToken = Cookies.get('scopio_customer_token');

  var reqHeader = {
    'Authorization': 'Bearer ' + customerToken,
  };

  return $.ajax({
    method: 'GET',
    url: 'https://api.scop.io/me/boards',
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    headers: reqHeader,
    statusCode: {
      400: function (response) {
        console.error(response);

        return response;
      },
      401: function (response) {
        console.error(response);

        return response;
      },
      403: function (response) {
        areBoardsAvailable = false;

        return response;
      }
    },
    success: function (data) {
      return data.data;
    }
  });
}

var addImageToBoard = function(boardId, photoId, callback){
  const customerToken = Cookies.get('scopio_customer_token');

  var reqHeader = {
    'Authorization': 'Bearer ' + customerToken,
  };

  var reqBody = {
    "shopify_photo_id": photoId
  };

  $.ajax({
    method: 'POST',
    url: 'https://api.scop.io/me/boards/' + boardId + '/photos',
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    data: JSON.stringify(reqBody),
    headers: reqHeader,
  }).done(function (data) {
    if(callback) {
      callback();
      return;
    }

    showCheckGridIcon(photoId);
  }).fail(function (err) {
  });
}

var createNewBoard = function(boardName, currentImg, callback){
  const customerToken = Cookies.get('scopio_customer_token');

  var reqBody = {
    "name": boardName,
    "public": false
  };

  var reqHeader = {
    'Authorization': 'Bearer ' + customerToken,
  };

  $.ajax({
    method: 'POST',
    url: 'https://api.scop.io/me/boards',
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    data: JSON.stringify(reqBody),
    headers: reqHeader,
    statusCode: {
      400: function (response) {
        console.error(response);
      },
      401: function (response) {
        console.error(response);
      },
      403: function (response) {
        location.href = '/account?view=subscription';
      }
    },
    success: function (data) {
      var newBoard = data.data;
      addImageToBoard(newBoard.id, currentImg, callback);
      addBoardToAllPhotos(newBoard);
      closeNewBoardModal();
      document.getElementById("newBoardInput").value = "";
    }
  });
}

var closeNewBoardModal = function() {
  var boardModal = document.getElementById("boardModal");
  boardModal.style.display = "none";
}

var showCheckGridIcon = function(photoId) {
  console.log(photoId);
  var saveButton = document.getElementById('saveButton' + photoId);
  saveButton.style.opacity = "0";
  var checkIcon = document.getElementById('checkContainerIcon' + photoId);
  checkIcon.style.display = "flex";

  setTimeout(() => {
      checkIcon.style.display = "none";
      saveButton.style.opacity = "1";
  }, 3000);
}

var sideScroll = function(elementId, isRight){
  var scrollAmount = 0;
  var speed = 15;
  var distance = 900;
  var step = 200;
  var element = document.getElementById(elementId);
  var slideTimer = setInterval(function(){
    if(isRight){
      element.scrollLeft += step;
    } else {
      element.scrollLeft -= step;
    }

    scrollAmount += step;

    if(scrollAmount >= distance){
      window.clearInterval(slideTimer);
    }

    setTimeout(displayCarouselButtons, scrollAmount);
  }, speed);
}

var displayCarouselButtons = function() {
  if(divRelatedSearches.scrollLeft <= carouselBtnWidth) {
    aCarouselPrev.style.display = 'none';
  } else {
    aCarouselPrev.style.display = 'block';
  }

  if(divRelatedSearches.scrollLeft + divRelatedSearchesWrapper.offsetWidth + carouselBtnWidth >= divRelatedSearches.scrollWidth) {
    aCarouselNext.style.display = 'none';
  } else {
    aCarouselNext.style.display = 'block';
  }
}

if(searchFormWrapper) {
  searchFormWrapperOffset = offset(searchFormWrapper);

  document.addEventListener("scroll", function(searchFormWrapper, searchFormSpacing, e) {
    if (window.pageYOffset > searchFormWrapperOffset.top - 20) {
      searchFormWrapper.classList.add("fix-top");
      searchFormSpacing.classList.add("search-fixed");
    } else {
      searchFormWrapper.classList.remove("fix-top");
      searchFormSpacing.classList.remove("search-fixed");
    }
  }.bind(document, searchFormWrapper, searchFormSpacing));
}

document.addEventListener("scroll", function() {
  if(isSearchLoading === false && isPageLoading === false
      && isHomepage === false && isProductPage === false
      && lastSearchParams && lastSearchParams.searchData
      && lastDocumentHeightLoaded < document.body.offsetHeight
      && window.innerHeight + window.scrollY >= document.body.offsetHeight - 1000) {
    lastSearchParams.searchData.page++;

    lastDocumentHeightLoaded = document.body.offsetHeight;

    if(lastSearchParams.isFallback === true) {
      shopifyCollectionFallback(
        lastSearchParams.searchData.handle,
        lastSearchParams.containerId,
        lastSearchParams.searchData.page,
        lastSearchParams.searchData.page_size,
        lastSearchParams.callback,
        lastSearchParams.isVendor
      );
    } else {
      if (searchType === 'images') {
        runSearch(
          lastSearchParams.searchData,
          lastSearchParams.containerId,
          lastSearchParams.alternativeSearch,
          lastSearchParams.disablePagination,
          lastSearchParams.callback
        );
      } else if (searchType === 'stories' || searchType === 'people') {
        //document.getElementById('loading-search-results').style.display = 'block';
        document.getElementById('search_type').value = searchType;
        runStoriesPeopleSearch({
          query: scopioSearchQuery,
          type: searchType,
          country: locationCountry || selectedCountry,
          city: locationCity || selectedCity,
          state: locationState,
          gender: selectedGender,
          ethnicities: selectedEthnicities,
          skills: selectedSkills,
        }, 'scopio-people-search-results', () => {}, lastSearchParams.disablePagination);
      }
    }
  }
});

window.addEventListener('load', function() {
  isPageLoading = false;

  getUserBoards()
    .then(res =>{
      customerBoards = res.data;
      customerBoardsLoaded = true;
    })
    .catch(err => {
      customerBoards = [];
      customerBoardsLoaded = true;
    });

  if (cityField && cityFieldMob) {
    var autocompleteOptions = {
      types: ["(cities)"],
    };

    if (selectedCountry) {
      autocompleteOptions.componentRestrictions = {
        country: selectedCountry,
      };
    }

    autocompleteCity = new google.maps.places.Autocomplete(cityField, autocompleteOptions);
    autocompleteCity.addListener('place_changed', placeChangeHandler.bind(this, 'city'));

    autocompleteCityMob = new google.maps.places.Autocomplete(cityFieldMob, autocompleteOptions);
    autocompleteCityMob.addListener('place_changed', placeChangeHandler.bind(this, 'city_mob'));
  }
});

window.addEventListener('resize', closeFilterDropdowns);

if (searchForm) {
  searchForm.addEventListener('submit', searchSubmissionHandler);
  btnClearCountry.addEventListener('click', clearFilterAction);
  btnClearGender.addEventListener('click', clearFilterAction);
  btnClearEthnicity.addEventListener('click', clearFilterAction);
  btnClearSkills.addEventListener('click', clearFilterAction);
  btnClearLicense.addEventListener('click', clearFilterAction);
  btnClearOrientation.addEventListener('click', clearFilterAction);
  btnClearMob.addEventListener('click', clearMobFilters);

  genderFields.forEach((gender) => {
    gender.addEventListener('click', syncDuplicatedFilter);
  });

  genderMobFields.forEach((genderMob) => {
    genderMob.addEventListener('click', syncDuplicatedFilter);
  });

  ethnicityFields.forEach((ethnicity) => {
    ethnicity.addEventListener('click', syncDuplicatedFilter);
  });

  skillsFields.forEach((skill) => {
    skill.addEventListener('click', syncDuplicatedFilter);
  });

  cityField.addEventListener('blur', syncCityFilter);
  cityFieldMob.addEventListener('blur', syncCityFilter);

  countryField.addEventListener('change', changeCountry);
  countryFieldMob.addEventListener('change', changeCountry);

  licenseFields.forEach((license) => {
    license.addEventListener('click', syncDuplicatedFilter);
  });

  licenseMobFields.forEach((licenseMob) => {
    licenseMob.addEventListener('click', syncDuplicatedFilter);
  });

  orientationFields.forEach((orientation) => {
    orientation.addEventListener('click', syncDuplicatedFilter);
  });

  orientationMobFields.forEach((orientationMob) => {
    orientationMob.addEventListener('click', syncDuplicatedFilter);
  });

  window.addEventListener('popstate', popstateHandler);
}

if(divRelatedSearches) {
  divRelatedSearches.addEventListener('scroll', displayCarouselButtons);
}

document.addEventListener('related_searches_loaded', function() {
  if(divRelatedSearches.hasChildNodes()) {
    divRelatedSearchesWrapper.style.display = 'block';

    if(!searchFormSpacing.classList.contains('with-related-searches')) {
      searchFormSpacing.classList.add('with-related-searches');
    }
  }

  if (divRelatedSearches.scrollWidth > divRelatedSearchesWrapper.offsetWidth) {
    aCarouselNext.style.display = 'block';
  } else {
    aCarouselNext.style.display = 'none';
  }
});
